<script setup lang="ts">
import { Permission } from "../../types/auth";
import type { TableField, TableAction } from "./table";
import IconComponent from "../../components/ui/common/IconComponent.vue";
import { formatFieldValue } from "./tableUtils";
import { hasPermission } from "../../utils/CommonFunctions";
import AsyncImage from "../ui/form/AsyncImage.vue";

const props = defineProps<{
  items: any[];
  fields: TableField[];
  actions: TableAction[];
  permissions?: Permission[];
  showActions: boolean;
  allowDisable: boolean;
  showQuickView: boolean;
  titleField?: string;
}>();

defineEmits<{
  (e: "action", action: string, item: any): void;
}>();
</script>

<template>
  <div class="md:hidden space-y-4" id="table-records">
    <div
      v-if="items && items.length > 0"
      v-for="item in items"
      :key="item.id"
      class="bg-white dark:bg-gray-900 rounded-lg shadow p-4 border border-gray-200 dark:border-gray-700"
    >
      <div
        class="flex justify-between items-start mb-4"
        v-if="props.titleField"
      >
        <h3 class="font-medium text-gray-900 dark:text-white">
          {{ item[props.titleField] }}
        </h3>
        <div
          v-if="fields.find((f) => f.fieldType === 'status')"
          v-html="formatFieldValue(item.active, 'status')"
        ></div>
      </div>

      <!--<div class="flex justify-between items-start mb-4" v-if="fields.find(f => f.fieldType === 'status')">
        <h3 class="font-medium text-gray-900 dark:text-white" v-html="formatFieldValue(item[fields[0].name], fields[0].fieldType)"></h3>
        <div v-if="fields.find(f => f.fieldType === 'status')" v-html="formatFieldValue(item.active, 'status')"></div>
      </div>-->

      <div class="space-y-2 text-sm">
        <div
          v-for="field in fields"
          :key="field.name"
          class="flex items-start justify-between"
          v-show="field.fieldType !== 'status'"
        >
          <AsyncImage
            v-if="field.fieldType == 'image'"
            :src="item[field.name]"
            :alt="item['name']"
            :readonly="true"
            className="max-w-[75px]"
          />
          <template v-else>
            <span class="text-gray-500 dark:text-gray-400">{{
              field.caption
            }}</span>
            <span
              class="font-medium"
              v-html="formatFieldValue(item[field.name], field.fieldType)"
            ></span>
          </template>
        </div>
      </div>

      <div
        v-if="actions.length && showActions == true"
        class="mt-4 flex justify-end space-x-2 border-t dark:border-gray-700 pt-4"
        id="mobile-table-actions"
      >
        <template v-for="action in props.actions">
          <button
            v-if="
              (hasPermission(props.permissions, action.title) ||
                hasPermission(props.permissions, action.permission) ||
                action.ignorePermission) &&
              (typeof action.visible === 'function'
                ? action.visible(item)
                : action.visible) &&
              !action.hideMobile
            "
            :key="action.name"
            @click="$emit('action', action.name, item)"
            :class="[
              'p-2',
              'text-' +
                action.variant +
                '-600 hover:text-' +
                action.variant +
                '-700',
              'dark:text-' +
                action.variant +
                '-400 dark:hover:text-' +
                action.variant +
                '-300',
            ]"
            :title="action.title"
          >
            <IconComponent :name="action.icon" />
          </button>
        </template>
      </div>
    </div>
    <div
      v-else
      class="bg-white dark:bg-gray-900 rounded-lg shadow p-4 border border-gray-200 dark:border-gray-700"
    >
      <div class="space-y-2 text-sm">
        <div>No records found</div>
      </div>
    </div>
  </div>
</template>
